var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value)?_c('div',{staticClass:"df-container df-toast"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"toast",class:{none:_vm.type == 'none'}},[_c('i',{staticClass:"iconfont",class:_vm.type}),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.info.content))])])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f5ca6c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/flexible-ui/toast.vue
// module id = null
// module chunks = 